import {tmsPackageEnabled} from '@netx/core-cart-next/enablers/tmsPackageEnabled';
import {
	PermissionName,
	currentUserHasAccess,
} from '@netx/core-permissions-next/enablers';
import {currentCartIsEmpty} from './currentCartIsEmpty';

export const canCreateTMSObjectFromCurrentCart = (): boolean => {
	if (currentCartIsEmpty()) return false;
	if (!tmsPackageEnabled()) return false;
	return currentUserHasAccess(PermissionName.DOWNLOAD);
};
